import { all, fork } from 'redux-saga/effects';
import { watchAppActions } from '../user-management/appSaga';
import { watchMapActions } from '../features/main-map/mapSaga';
import { watchMSIValueActions } from '../features/value/valueSaga';
import watchPortfolioActions from '../features/portfolio/portfolioSaga';
import watchFilterActions from '../features/filter/filterSaga';
import { watchDcfActions } from '../features/dcf/dcfSaga';
import { watchKpiActions } from '../features/kpis/kpiSaga';
import { watchGreenActions } from '../features/green/greenSaga';
import { watchDownloadActions } from '../features/download/downloadSaga';
import { watchPortActions } from '../features/port/portSaga';


const rootSaga = function* () {
	yield all([
		fork(watchAppActions),
		fork(watchMapActions),

		fork(watchPortfolioActions),
		fork(watchFilterActions),
		fork(watchPortActions),

		fork(watchMSIValueActions),
		fork(watchDcfActions),
		fork(watchKpiActions),
		fork(watchGreenActions),
		fork(watchDownloadActions),
		// Other forks
	]);
};

export default rootSaga;
